<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1752_998)">
      <path
        d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
        fill="white"
      />
      <path
        d="M5.93906 10.6311L2.7125 7.40449C2.66875 7.36074 2.66875 7.29512 2.7125 7.25137L3.64219 6.32168C3.68594 6.27793 3.75156 6.27793 3.79531 6.32168L6.01563 8.54199L10.1938 4.36387C10.2375 4.32012 10.3031 4.32012 10.3469 4.36387L11.2766 5.29355C11.3203 5.3373 11.3203 5.40293 11.2766 5.44668L6.09219 10.6311C6.04844 10.6748 5.98281 10.6748 5.93906 10.6311Z"
        fill="#10cd00"
      />
    </g>
    <defs>
      <clipPath id="clip0_1752_998">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    },
  },
};
</script>
